<template>
  <div>
    <!-- MENSAJES -->
    <mensajeSistema></mensajeSistema>

    <!-- BUTÓN CREAR Y CARDS -->
    <v-row>
      <v-col class="d-flex flex-row-reverse">
        <v-btn class="primary" @click="openModalCondicional(null)">
          <v-icon left>fas fa-plus</v-icon>
          Crear condicionales a los grados
        </v-btn>
      </v-col>
    </v-row>

    <v-row v-if="normativas_condicionales_grados.length !== 0 && !loading" align="center" justify="center">
      <v-col
        class="d-flex justify-center"        
        xs="12"
        sm="6"
        md="4"
        lg="3"
        v-for="(item, index) in normativas_condicionales_grados"
        :key="index"
      >
        <v-card max-width="300" height="470">
          <v-toolbar dense :color="item.color" dark>
            <v-icon left>mdi-checkbox-multiple-blank</v-icon>
            <b>{{ item.nombre_normativa }}</b>
          </v-toolbar>

          <v-card-title>
            <v-chip label outlined dark :color="item.color">
              {{ item.tipo_condicion_desc }}
            </v-chip>
          </v-card-title>

          <v-card-text class="styleCardsText">
            <perfect-scrollbar class="styleCards">
              <div v-html="item.descripcion_condicion"></div>
            </perfect-scrollbar>

            <v-divider class="my-4"></v-divider>
            <div class="text-h6 font-weight-regular grey--text">
              Nivel: {{ item.desc_nivel }}
            </div>

              <v-chip-group active-class="primary accent-4 white--text" column>
                <v-chip
                  v-for="(grados, index) in item.id_grado_ck1"
                  :key="index"
                  >{{ grados.desc_grado }}</v-chip
                >
              </v-chip-group>             
          </v-card-text>


       

          <!-- openModalInformacionCondicional -->
          <v-card-actions>
              <v-btn
                block
                color="warning"
                text
                @click="openModalCondicional(item)"
              >
                Ver información
              </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-sheet
      v-else-if="normativas_condicionales_grados.length == 0 && loading"
      :color="`grey lighten-4`"
      class="mt-4 pa-3"
    >
      <v-row>
        <v-col cols="3" v-for="num in 4" :key="num">
          <v-skeleton-loader
            class="mx-auto"
            max-width="300"
            type="card"
          ></v-skeleton-loader>
        </v-col>
      </v-row>
    </v-sheet>

    <v-row v-else justify="center" style="background: #f4f4f4">
      No hay resultados <strong class="ml-1"> disponibles</strong>
    </v-row>

    <!-- MODAL CREACIÓN -->
    <v-form ref="validaFormCampos" lazy-validation v-model="isValid">
      <v-dialog
        v-model="modalCondiciones"
        scrollable
        max-width="1200px"
        persistent
      >
        <v-card>
          <v-card-title class="btn_otro">
            <label>
              <v-icon dark>mdi-tag-multiple</v-icon>
              {{
                `${tituloModal} condiciones de las normativas ministeriales.`
              }}
            </label>
            <v-spacer></v-spacer>
            <v-btn
              fab
              dark
              x-small
              class="btn_style3"
              @click="modalCondiciones = false"
            >
              <v-icon dark>fa-times</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <perfect-scrollbar class="pa-3">
            <v-card-text class="pt-4">
              <v-row>
                <v-col cols="3">
                  <v-autocomplete
                    label="Seleccione la normativa"
                    :items="normativas_ministeriales"
                    v-model="id_normativa"
                    item-text="nombre_normativa"
                    return-object
                    @change="SeleccionarNormativa($event)"
                    :rules="validationRules.validateCampo"
                  >
                  </v-autocomplete>
                </v-col>

                <v-col cols="3">
                  <v-select
                    label="Tipo de promoción"
                    :items="tipos_promocion"
                    v-model="id_tipos_promocion"
                    item-value="id"
                    item-text="descripcion"
                    :rules="validationRules.validateCampo"
                  >
                  </v-select>
                </v-col>

                <v-col cols="3">
                  <v-select
                    label="Nivel"
                    :items="niveles_grados"
                    v-model="nivelSeleccionado"
                    item-value="id_nivel"
                    item-text="desc_nivel"
                    return-object
                    @change="SeleccionarNivel($event)"
                    :rules="validationRules.validateCampo"
                  >
                  </v-select>
                </v-col>

                <v-col cols="3">
                  <v-select
                    label="Grado"
                    :items="grados"
                    v-model="gradosSeleccionados"
                    item-value="id_grado"
                    item-text="desc_grado"
                    multiple
                    return-object
                    :rules="validationRules.validateCampo"
                  >
                  </v-select>
                </v-col>

                <v-col cols="8">
                  <v-autocomplete
                    v-model="areas_permitidas"
                    :items="todasAreas"
                    chips
                    label="Selecciona areas permitidas"
                    item-text="desc_area"
                    item-value="id"
                    multiple
                    return-object
                    :rules="validationRules.validateCampo"
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        small
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        close
                        @click="data.select"
                        @click:close="removerChips(data.item)"
                      >
                        <v-avatar left>
                          <v-icon small :color="data.item.color_area">{{
                            data.item.icono_area
                          }}</v-icon>
                        </v-avatar>
                        {{ data.item.desc_area }}
                      </v-chip>
                    </template>
                    <template v-slot:item="data">
                      <template>
                        <v-icon left small :color="data.item.color_area">{{
                          data.item.icono_area
                        }}</v-icon>
                        <small> {{ data.item.desc_area }}</small>
                      </template>
                    </template>
                  </v-autocomplete>
                </v-col>

                <v-col v-if="id_tipos_promocion == 1" cols="4">
                  <v-radio-group
                    row
                    label="Promoción automatica"
                    v-model="promocion_automatica"
                    :rules="validationRules.validateCampoNulos"
                    @change="radioButtonPromoAuto()"
                  >
                    <v-radio label="Si" color="success" :value="true">
                    </v-radio>
                    <v-radio label="No" color="red" :value="false"> </v-radio>
                  </v-radio-group>
                </v-col>

                <v-col v-if="id_tipos_promocion == 3" cols="4">
                  <v-radio-group
                    row
                    label="Sino cumple con los requerimientos de promoción o permanencia de grado, participa en recuperación pedagógica."
                    v-model="sino_cumple_con_ni_uno"
                    @change="radioButtonSinoCumple()"
                    hide-details
                  >
                    <v-radio label="Si" color="success" :value="true">
                    </v-radio>
                    <v-radio label="No" color="red" :value="false"> </v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>

              <v-row
                v-if="
                  (promocion_automatica == false && id_tipos_promocion == 1) ||
                  id_tipos_promocion == 2 ||
                  (sino_cumple_con_ni_uno == false && id_tipos_promocion == 3)
                "
                class="conclass1"
              >
                <v-col cols="12" class="colstyle">
                  <v-radio-group
                    row
                    v-model="area_aleatoria"
                    @change="radioButtonAreasAleatorias()"
                  >
                    <template v-slot:label>
                      <div>
                        <strong>
                          ¿Desea que el sistema escoja las
                          <a class="primary--text">
                            áreas de manera aleatoria?
                          </a></strong
                        >
                      </div>
                    </template>
                    <v-radio label="Si" color="primary" :value="true">
                    </v-radio>
                    <v-radio label="No" color="red" :value="false"> </v-radio>
                  </v-radio-group>
                </v-col>

                <v-col v-if="area_aleatoria == false" cols="3">
                  <v-select
                    label="Áreas seleccionables"
                    :items="areas_permitidas"
                    v-model="areas_seleccionadas"
                    item-value="id"
                    item-text="desc_area"
                    multiple
                    return-object
                  >
                  </v-select>
                </v-col>

                <v-col v-else cols="3">
                  <v-select
                    label="Cantidad de áreas"
                    v-model="cantidad_areas_nivel_n_objeto"
                    :items="cantidadAreas"
                    item-value="id"
                    item-text="text"
                    @change="changeQtyAreas($event)"
                    return-object
                    :rules="validationRules.validateCampo"
                  >
                  </v-select>
                </v-col>

                <v-col cols="2">
                  <v-select
                    label="Nivel de logro"
                    :items="filtro_calificacionesL"
                    item-value="id"
                    item-text="literal"
                    v-model="id_calif_literal"
                    multiple
                    return-object
                    :rules="validationRules.validateCampo"
                  >
                  </v-select>
                </v-col>

                <v-col cols="3">
                  <v-select
                    label="Condición / Operador"
                    :items="itemsCondiciones"
                    item-value="valor"
                    item-text="desc"
                    v-model="valor_condicion"
                    :rules="validationRules.validateCampo"
                  >
                  </v-select>
                </v-col>

                <v-col cols="4">
                  <div class="text-caption">Porcentaje de competencias</div>
                  <v-slider
                    class="mt-3"
                    v-model="porcentaje_competencias"
                    track-color="red"
                    thumb-label="always"
                    :thumb-size="37"
                    hide-details
                  >
                    <template v-slot:append>
                      <v-text-field
                        v-model="porcentaje_competencias"
                        class="mt-0 pt-0"
                        hide-details
                        single-line
                        type="number"
                        style="width: 60px; margin-top: -20px !important"
                      ></v-text-field>
                    </template>
                    <template v-slot:thumb-label="{ value }">
                      {{ value }}%
                    </template>
                  </v-slider>
                </v-col>

                <v-col cols="8">
                  <v-radio-group
                    class="radiogroupnormas"
                    row
                    label="¿Establecer nivel de logro a competencias restantes de las áreas seleccionadas?"
                    v-model="comp_restantes"
                    @change="radioButtonAreasAleatorias()"
                  >
                    <v-radio label="Si" color="primary" :value="true">
                    </v-radio>
                    <v-radio label="No" color="red" :value="false"> </v-radio>
                  </v-radio-group>
                </v-col>

                <v-col cols="4" class="pt-0" v-if="comp_restantes">
                  <v-select
                    class="pt-1"
                    label="Nivel de logro competencias restantes"
                    :items="filtro_calificacionesL_restantes"
                    item-value="id"
                    item-text="literal"
                    v-model="id_calif_literal_comp_restantes"
                    multiple
                    return-object
                    :rules="validationRules.validateCampo"
                  >
                  </v-select>
                </v-col>
              </v-row>

              <v-row
                v-if="
                  (promocion_automatica == false && id_tipos_promocion == 1) ||
                  id_tipos_promocion == 2 ||
                  (sino_cumple_con_ni_uno == false && id_tipos_promocion == 3)
                "
                class="conclass2"
              >
                <v-col cols="12" class="colstyle">
                  <v-radio-group
                    v-model="cond_areas_restantes"
                    @change="radioButtonCondAreasRest()"
                    row
                  >
                    <template v-slot:label>
                      <div>
                        <strong>
                          ¿Desea añadir condiciones a las
                          <a class="success--text">
                            áreas restantes?
                          </a></strong
                        >
                      </div>
                    </template>
                    <v-radio label="Si" color="success" :value="true">
                    </v-radio>
                    <v-radio label="No" color="red" :value="false"> </v-radio>
                  </v-radio-group>
                </v-col>

                <v-col
                  v-if="area_aleatoria == false && cond_areas_restantes == true"
                  cols="3"
                >
                  <v-select
                    label="Áreas restantes"
                    :items="areas"
                    v-model="areas_seleccionadas_restantes"
                    item-value="id"
                    item-text="desc_area"
                    multiple
                    return-object
                  >
                  </v-select>
                </v-col>

                <v-col v-else-if="cond_areas_restantes == true">
                  <v-select
                    label="Cantidad de áreas restantes"
                    v-model="cantidad_areas_nivel_restantes_objeto"
                    :items="cantidadAreasRestantes"
                    item-color="success"
                    item-value="id"
                    item-text="text"
                    @change="changeQtyAreasRest($event)"
                    return-object
                    :rules="validationRules.validateCampo"
                  >
                  </v-select>
                </v-col>

                <v-col v-if="cond_areas_restantes == true" cols="2">
                  <v-select
                    label="Nivel de logro"
                    :items="calif_literal"
                    item-value="id"
                    item-color="success"
                    item-text="literal"
                    v-model="id_calif_literal_restantes"
                    multiple
                    return-object
                    :rules="validationRules.validateCampo"
                  >
                  </v-select>
                </v-col>

                <v-col v-if="cond_areas_restantes == true" cols="3">
                  <v-select
                    label="Condición / Operador"
                    :items="itemsCondiciones"
                    item-value="valor"
                    item-color="success"
                    item-text="desc"
                    v-model="valor_condicion_restantes"
                    :rules="validationRules.validateCampo"
                  >
                  </v-select>
                </v-col>

                <v-col v-if="cond_areas_restantes == true" cols="4">
                  <div class="text-caption">Porcentaje de competencias</div>
                  <v-slider
                    class="mt-3"
                    v-model="porcentaje_competencias_restantes"
                    track-color="red"
                    thumb-label="always"
                    :thumb-size="37"
                    hide-details
                  >
                    <template v-slot:append>
                      <v-text-field
                        v-model="porcentaje_competencias_restantes"
                        class="mt-0 pt-0"
                        hide-details
                        single-line
                        type="number"
                        style="width: 60px; margin-top: -20px !important"
                      ></v-text-field>
                    </template>
                    <template v-slot:thumb-label="{ value }">
                      {{ value }} %
                    </template>
                  </v-slider>
                </v-col>
              </v-row>

              <v-row
                v-if="
                  (promocion_automatica == false && id_tipos_promocion == 1) ||
                  id_tipos_promocion == 2 ||
                  (sino_cumple_con_ni_uno == false && id_tipos_promocion == 3)
                "
              >
                <v-col cols="12" class="d-flex justify-center"
                  ><v-icon>mdi-arrow-down-thick</v-icon></v-col
                >
                <v-col cols="12" class="d-flex justify-center pa-0">
                  <v-alert
                    width="80%"
                    class="animate__animated animate__pulse animate__infinite"
                    icon="mdi-information-outline"
                    dense
                    outlined
                    border="left"
                    text
                    elevation="2"
                    :type="
                      id_tipos_promocion == 1
                        ? 'success'
                        : id_tipos_promocion == 2
                        ? 'error'
                        : 'warning'
                    "
                  >
                    <div
                      class="enunciadoAlert"
                      v-html="EnunciadoPersonalizado"
                    ></div>
                  </v-alert>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-actions>
              <!-- BOTÓN CREAR CONDICIÓN -->
              <v-col
                v-if="tituloModal == 'Crear'"
                class="d-flex flex-row-reverse"
              >
                <v-btn class="primary" @click="crearCondicion()">
                  <v-icon left>fas fa-plus</v-icon>
                  Crear
                </v-btn>
              </v-col>
            </v-card-actions>
          </perfect-scrollbar>
        </v-card>
      </v-dialog>
    </v-form>
  </div>
</template>

<script>
import axios from "../../../../helpers/axios";
import { mapMutations } from "vuex";
// import { validationRules } from '..';
import { validationRules } from "../../../../helpers/validatorHelpers";

export default {
  components: {},
  props: ["normativas_ministeriales"],
  data: () => ({
    tituloModal: "",
    isValid: false,
    areas_permitidas: null,
    todasAreas: [],
    itemsCondiciones: [
      { valor: ">", desc: "Mayor a" },
      { valor: "<", desc: "Menor a" },
      { valor: "=", desc: "Igual a" },
      { valor: ">=", desc: "Mayor o igual a" },
      { valor: "<=", desc: "Menor o igual a" },
    ],
    // Modales
    modalCondiciones: false,
    modalInformacion: false,
    selection: false,
    loading: false,
    // Variables
    normativas_condicionales_grados: [],
    tipos_promocion: [],
    areas: [],
    calif_literal: [],
    niveles_grados: [],
    grados: [],
    // Variables seleccionadas
    // descripcion_condicion: "",
    id_normativa: null,
    normativaSeleccionada: null,
    id_tipos_promocion: null,
    promocion_automatica: null,
    // Variables condicionales
    sino_cumple_con_ni_uno: null,
    area_aleatoria: true,
    areas_seleccionadas: null,
    cantidad_areas_nivel_n: null,
    cantidad_areas_nivel_n_objeto: null,
    id_pais: null,
    id_calif_literal: null,
    valor_condicion: null,
    valor_condicion_restantes: "=",
    nivelSeleccionado: null,
    gradosSeleccionados: null,
    porcentaje_competencias: 50,
    cond_areas_restantes: false,
    id_calif_literal_restantes: null,
    areas_seleccionadas_restantes: null,
    cantidad_areas_nivel_restantes: null,
    cantidad_areas_nivel_restantes_objeto: null,
    porcentaje_competencias_restantes: 100,
    comp_restantes: false,
    id_calif_literal_comp_restantes: [],
  }),
  computed: {
    /** 
         ___________________________________________________________________
        |     PROPIEDAD PARA OBTENER EL NIVEL DE LOGRO PARA ENUNCIADO     */
    notasLogrosFiltradasEnunciado() {
      return this.id_calif_literal
        ? this.id_calif_literal.map((nota) => nota.literal).join(" o ")
        : "";
    },
    /** 
         _________________________________________________________________________________________________
        |     PROPIEDAD PARA OBTENER EL NIVEL DE LOGRO DE LAS COMPETENCIAS RESTANTES PARA ENUNCIADO     */
    notasLogrosCompetenciasRestantesFiltradasEnunciado() {
      return this.id_calif_literal_comp_restantes
        ? this.id_calif_literal_comp_restantes
            .map((nota) => nota.literal)
            .join(" o ")
        : "";
    },
    /** 
         _______________________________________________________________________
        |     PROPIEDAD PARA CONDICIONAR LOS TEXTOS CON BASE A LOS SIGNOS     */
    enunciadofiltroSigno() {
      let enunciado = "";

      switch (this.valor_condicion) {
        case ">":
          enunciado = `en más del <strong>${this.porcentaje_competencias}%</strong> de las competencias`;
          break;
        case "<":
          enunciado = `en menos del <strong>${this.porcentaje_competencias}%</strong> de las competencias`;
          break;
        case "=":
          enunciado = `en el <strong>${this.porcentaje_competencias}%</strong> de las competencias`;
          break;
        case ">=":
          enunciado = `en el <strong>${this.porcentaje_competencias}%</strong> o más de las competencias`;
          break;
        case "<=":
          enunciado = `en el <strong>${this.porcentaje_competencias}%</strong> o menos de las competencias`;
          break;
      }
      return enunciado;
    },
    /** 
         _____________________________________________________________________________________________
        |     PROPIEDAD PARA CONDICIONAR LOS TEXTOS CON BASE A LOS SIGNOS DE LAS AREAS RESTANTES    */
    enunciadofiltroSignoAreasRestantes() {
      let enunciado = "";

      switch (this.valor_condicion_restantes) {
        case ">":
          enunciado =
            this.porcentaje_competencias_restantes == 100
              ? `en todas las competencias`
              : `en más del <strong>${this.porcentaje_competencias_restantes}%</strong> de las competencias`;
          break;
        case "<":
          enunciado =
            this.porcentaje_competencias_restantes == 100
              ? `en todas las competencias`
              : `en menos del <strong>${this.porcentaje_competencias_restantes}%</strong> de las competencias`;
          break;
        case "=":
          enunciado =
            this.porcentaje_competencias_restantes == 100
              ? `en todas las competencias`
              : `en el <strong>${this.porcentaje_competencias_restantes}%</strong> de las competencias`;
          break;
        case ">=":
          enunciado =
            this.porcentaje_competencias_restantes == 100
              ? `en todas las competencias`
              : `en el <strong>${this.porcentaje_competencias_restantes}%</strong> o más de las competencias`;
          break;
        case "<=":
          enunciado =
            this.porcentaje_competencias_restantes == 100
              ? `en todas las competencias`
              : `en el <strong>${this.porcentaje_competencias_restantes}%</strong> o menos de las competencias`;
          break;
      }
      return enunciado;
    },
    /** 
         ______________________________________________________________________________________________________________
        |     PROPIEDAD PARA OBTENER EL NIVEL DE LOGRO DE LAS COMPETENCIAS DE LAS AREAS RESTANTES PARA ENUNCIADO     */
    notasLogrosFiltradasAreasRestantesEnunciado() {
      return this.id_calif_literal_restantes
        ? this.id_calif_literal_restantes
            .map((nota) => nota.literal)
            .join(" o ")
        : "";
    },
    /** 
         _____________________________________________
        |     PROPIEDAD ENUNCIADO PERSONALIZADO     */
    EnunciadoPersonalizado() {
      //----------------------------------------------
      // LOGICA PARA MENSAJE DE AREAS SELECCIONADAS
      //----------------------------------------------
      const PromocionAuto = `<strong>Enunciado</strong>: El alumno realiza promocion automática`;
      const notasLogros = this.notasLogrosFiltradasEnunciado
        ? `<strong>"${this.notasLogrosFiltradasEnunciado}"</strong>`
        : "...";
      const cantidadAreas = this.cantidad_areas_nivel_n
        ? `de <strong>${this.cantidad_areas_nivel_n}</strong> áreas`
        : "...";
      const compRestantes = this.comp_restantes
        ? `${this.cond_areas_restantes ? "," : "y"} <strong>"${
            this.notasLogrosCompetenciasRestantesFiltradasEnunciado || "..."
          }"</strong> en las demás competencias de las mismas áreas `
        : "";
      //----------------------------------------------
      // LOGICA PARA MENSAJE DE AREAS RESTANTES
      //----------------------------------------------
      const notasLogrosRestantes = this
        .notasLogrosFiltradasAreasRestantesEnunciado
        ? `<strong>"${this.notasLogrosFiltradasAreasRestantesEnunciado}"</strong>`
        : "...";
      const cantidadAreasRestantes = this.cantidad_areas_nivel_restantes
        ? `de <strong>${this.cantidad_areas_nivel_restantes}</strong> áreas`
        : "...";
      const AreasRestantes = this.cond_areas_restantes
        ? `y ${notasLogrosRestantes} ${this.enunciadofiltroSignoAreasRestantes} las ${cantidadAreasRestantes} restantes`
        : `.`;

      return this.promocion_automatica
        ? PromocionAuto
        : `<strong>Enunciado</strong>: El alumno alcanza el nivel de logro ${notasLogros} ${this.enunciadofiltroSigno} ${cantidadAreas} ${compRestantes} ${AreasRestantes}`;
    },
    /** 
         ___________________________________________________________________________________________________________________
        |     PROPIEDAD PARA LISTAR LAS NOTAS DE LOGRO FILTRADAS DE LAS NOTAS DE LOGRO DE LAS COMPETENCIAS RESTANTES      */
    filtro_calificacionesL() {
      const selectedIds = this.id_calif_literal_comp_restantes.map(
        (item) => item.id
      );
      return this.calif_literal.filter(
        (item) => !selectedIds.includes(item.id)
      );
    },
    /** 
         ___________________________________________________________________________________________________________________
        |     PROPIEDAD PARA LISTAR LAS NOTAS DE LOGRO RESTANTES FILTRADAS DE LAS NOTAS DE LOGRO DE LAS COMPETENCIAS      */
    filtro_calificacionesL_restantes() {
      const selectedIds = this.id_calif_literal.map((item) => item.id);
      return this.calif_literal.filter(
        (item) => !selectedIds.includes(item.id)
      );
    },
    /** 
         _____________________________________
        |     PROPIEDAD LIMPIAR FORMULARIO     */
    cantidadAreas() {
      let cantidad_areas_nivel = [];
      if (this.areas_permitidas != null) {
        if (this.areas_permitidas.length > 0 && this.areas_permitidas) {
          const cantidadAreasPermitidas = this.areas_permitidas.length;
          cantidad_areas_nivel.push({
            id: 0,
            valor: cantidadAreasPermitidas,
            text: "Todas",
          });

          for (let i = 0; i < cantidadAreasPermitidas; i++) {
            cantidad_areas_nivel.push({ id: i + 1, valor: i + 1, text: i + 1 });
          }
        }
      }
      return cantidad_areas_nivel;
    },
    /** 
         ________________________________________
        |     PROPIEDAD LIMPIAR FORMULARIO     */
    cantidadAreasRestantes() {
      let cantidad_areas_nivel_restantes = [];

      const cantidadRestantes =
        this.areas_permitidas.length - this.cantidad_areas_nivel_n;

      if (cantidadRestantes > 0) {
        cantidad_areas_nivel_restantes.push({
          id: 0,
          valor: cantidadRestantes,
          text: "Todas",
        });

        for (let i = 0; i < cantidadRestantes; i++) {
          cantidad_areas_nivel_restantes.push({
            id: i + 1,
            valor: i + 1,
            text: i + 1,
          });
        }
      }
      return cantidad_areas_nivel_restantes;
    },
    /** 
         _____________________________________________________
        |     PROPIEDAD VALIDACION DE CAMPOS FORMULARIO     */
    validationRules() {
      return validationRules;
    },
  },
  mounted() {
    this.getNormativasCondicionales();
    this.getTiposNormativa();
    this.getCalifLiteral();
  },
  methods: {
    /** 
         _______________________________________
        |     METODO MENSAJES DEL SISTEMA     */
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    /** 
         _____________________________________________________________
        |     METODO OBTENER TODAS LAS NORMATIVAS Y CONDICIONES     */
    async getNormativasCondicionales() {
      this.loading = true;

      try {
        const response = await axios.get(
          "/cierreanio/cierreanioituacionestudiante/get-normativas-condicional-grado"
        );
        this.normativas_condicionales_grados = response.data;
        this.loading = false;
      } catch (error) {
        this.setEnviarMens({
          tipo: "E",
          message:
            "Error al traer las condicionales de las normativas ministeriales.",
        });
      }
    },
    /** 
         _________________________________________
        |     METODO OBTENER CANTIDAD AREAS     */
    changeQtyAreas(e) {
      this.cantidad_areas_nivel_n = e.valor;
    },
    /** 
         ___________________________________________________
        |     METODO OBTENER CANTIDAD AREAS RESTANTES     */
    changeQtyAreasRest(e) {
      this.cantidad_areas_nivel_restantes = e.valor;
    },
    /** 
         ________________________________________________________________________________
        |     METODO ELIMINAR CHIPS SELECCIONADOS EN EL SELELCTOR AREAS PERMITIDAS     */
    removerChips(item) {
      this.areas_permitidas = this.areas_permitidas.filter(
        (el) => el.id != item.id
      );
      this.cantidad_areas_nivel_n = null;
      this.cantidad_areas_nivel_n_objeto = null;
      this.cantidad_areas_nivel_restantes = null;
      this.cantidad_areas_nivel_restantes_objeto = null;
    },
    /** 
         _____________________________________________
        |     METODO ABRIR MODAL DE CONDICIONES     */
    openModalCondicional(data) {
      if (data) {
        this.tituloModal = "Ver";
        this.id_normativa = { nombre_normativa: data.nombre_normativa };
        this.id_tipos_promocion = data.id_tipos_promocion;

        //OBTENEMOS LOS NIVELES Y SELECIONADOS LOS DE LA DB
        const { niveles_grados_ck1 } = this.normativas_ministeriales.find(
          (el) => (el.id = data.id_normativa_ministerial)
        );
        this.niveles_grados = niveles_grados_ck1;
        this.nivelSeleccionado = data.id_nivel_ck1;
        this.getAreasCk1(data.id_nivel_ck1);

        //OBTENEMOS LOS GRADOS Y SELECIONAMOS LOS DE LA DB
        const { grados } = this.niveles_grados.find(
          (el) => el.id_nivel == this.nivelSeleccionado
        );
        this.grados = grados;
        this.gradosSeleccionados = data.id_grado_ck1;

        //OBTENEMOS LAS AREAS PERMITIDAS Y SELECIONAMOS LAS DE LA DB
        this.areas_permitidas = data.areas_permitidas;

        //OBTENEMOS SI ES PROMOCION AUTOMÁTICA
        this.promocion_automatica = data.promocion_automatica;
        //OBTENEMOS Sino cumple con los requerimientos de promoción o permanencia de grado, participa en recuperación pedagógica
        this.sino_cumple_con_ni_uno = data.no_cumple_requerimientos;

        //¿Desea que el sistema escoja las áreas de manera aleatoria? SI ---
        this.area_aleatoria = data.areas_aleatoria;
        this.cantidad_areas_nivel_n_objeto = {
          id: data.cantidad_de_areas,
          valor: data.cantidad_de_areas,
          text: data.cantidad_de_areas,
        };
        this.cantidad_areas_nivel_n = data.cantidad_de_areas;
        this.id_calif_literal = data.ids_calif_literal_nivel_logro;
        this.valor_condicion = data.porcentaje_competencias_condicion;
        this.porcentaje_competencias = data.porcentaje_competencias;
        //¿Desea que el sistema escoja las áreas de manera aleatoria? NO ---
        //  ... logica faltante.

        //¿Establecer nivel de logro a competencias restantes de las áreas seleccionadas?
        this.comp_restantes = data.areas_comp_restantes;
        this.id_calif_literal_comp_restantes =
          data.ids_calif_literal_nivel_logro_comp_restantes;

        this.cond_areas_restantes = data.areas_restantes_condiciones;

        // AREAS RESTANTES.
        this.cantidad_areas_nivel_restantes_objeto = {
          id: data.cantidad_areas_restantes,
          valor: data.cantidad_areas_restantes,
          text: data.cantidad_areas_restantes,
        };
        this.cantidad_areas_nivel_restantes = data.cantidad_areas_restantes;

        // NIVEL LOGRO AREAS RESTATES.
        this.id_calif_literal_restantes =
          data.ids_calif_literal_nivel_logro_areas_restantes;
        this.valor_condicion_restantes =
          data.porcentaje_competencias_areas_restantes_condicion;
        this.porcentaje_competencias_restantes =
          data.porcentaje_competencias_areas_restantes;
      } else {
        this.limpiarCampos();
        this.$refs.validaFormCampos.resetValidation();
        this.tituloModal = "Crear";
      }

      console.log({ data });
      this.modalCondiciones = true;
    },
    /** 
         ______________________________________________
        |     METODO OBTENER TIPOS DE NORMATIVAS     */
    async getTiposNormativa() {
      try {
        const response = await axios.get(
          "/cierreanio/cierreanioituacionestudiante/tipos-promocion"
        );

        if (response.data.length == 0) {
          this.setEnviarMens({
            tipo: "W",
            mensaje:
              "Debes crear los tipos de promoción primero desde la bd primero.",
            tiempo: 4000,
          });
        } else {
          this.tipos_promocion = response.data;
        }
      } catch (error) {
        console.log(error);
        this.setEnviarMens({
          tipo: "E",
          message: "Error al traer los tipos de normativas ministeriales.",
        });
      }
    },
    /** 
         ____________________________________
        |     METODO OBTENER AREAS CK1     */
    async getAreasCk1(item) {
      try {
        this.areas = [];

        let data = {
          id_nivel: item,
          id_pais: this.id_pais,
        };
        const response = await axios.post("/manager/areaCkOne/pais/", data);
        this.todasAreas = response.data;
      } catch (error) {
        console.log(error);
        this.setEnviarMens({
          tipo: "E",
          message: "Error al traer las áreas.",
        });
      }
    },
    /** 
         _______________________________________________
        |     METODO OBTENER CALIFICACION LITERAL     */
    async getCalifLiteral() {
      try {
        const response = await axios.get(
          "/mantenimiento/confCalificacionLiteral"
        );

        this.calif_literal = response.data;
      } catch (error) {
        console.log(error);
        this.setEnviarMens({
          Tipo: "E",
          message: "Error al traer las calificaciones literales.",
        });
      }
    },
    /** 
         __________________________________
        |     METODO CREAR CONDICION     */
    async crearCondicion() {
      if (!this.$refs.validaFormCampos.validate()) return;

      try {
        let data = {
          descripcion_condicion: this.EnunciadoPersonalizado,
          id_normativa_ministerial: this.id_normativa.id,
          id_tipos_promocion: this.id_tipos_promocion,
          id_nivel_ck1: this.nivelSeleccionado.id_nivel,
          id_grado_ck1: this.gradosSeleccionados,
          promocion_automatica: this.promocion_automatica,
          no_cumple_requerimientos: this.sino_cumple_con_ni_uno,
          areas_aleatoria: this.area_aleatoria,
          areas_comp_restantes: this.comp_restantes,
          id_area_ck1: this.areas_seleccionadas,
          cantidad_de_areas: this.cantidad_areas_nivel_n,
          ids_calif_literal_nivel_logro: this.id_calif_literal,
          ids_calif_literal_nivel_logro_comp_restantes:
            this.id_calif_literal_comp_restantes,
          porcentaje_competencias_condicion: this.valor_condicion,
          porcentaje_competencias_areas_restantes_condicion:
            this.valor_condicion_restantes,
          porcentaje_competencias: this.porcentaje_competencias,
          areas_restantes_condiciones: this.cond_areas_restantes,
          id_area_ck1_restantes: this.areas_seleccionadas_restantes,
          cantidad_areas_restantes: this.cantidad_areas_nivel_restantes,
          ids_calif_literal_nivel_logro_areas_restantes:
            this.id_calif_literal_restantes,
          porcentaje_competencias_areas_restantes:
            this.porcentaje_competencias_restantes,
          areas_permitidas: this.areas_permitidas,
        };

        const response = await axios.post(
          "/cierreanio/cierreanioituacionestudiante/create-normativa-condicional-grado",
          data
        );

        this.setEnviarMens({
          tipo: response.data.messageT,
          mensaje: response.data.message,
          tiempo: response.data.tiempo,
        });

        this.modalCondiciones = false;
        this.getNormativasCondicionales();
        // this.LimpiarFiltrado('todo');
      } catch (error) {
        console.log(error);
      }
    },
    /** 
         ________________________________________
        |     METODO SELECCIONAR NORMATIVA     */
    SeleccionarNormativa(item) {
      this.id_pais = item.id_pais;
      this.niveles_grados = item.niveles_grados_ck1;
    },
    /** 
         ____________________________________
        |     METODO SELECCIONAR NIVEL     */
    SeleccionarNivel(item) {
      this.grados = item.grados;
      this.getAreasCk1(item.id_nivel);
      // this.LimpiarFiltrado('select-nivel');
    },

    limpiarCampos() {
      this.id_normativa = null;
      this.id_tipos_promocion = null;
      this.niveles_grados = [];
      this.nivelSeleccionado = null;
      this.gradosSeleccionados = null;
      this.areas_permitidas = null;
      this.promocion_automatica = null;
      this.area_aleatoria = true;
      this.cantidad_areas_nivel_n_objeto = null;
      this.cantidad_areas_nivel_n = null;
      this.id_calif_literal = null;
      this.valor_condicion = null;
      this.porcentaje_competencias = 50;
      this.comp_restantes = false;
      this.id_calif_literal_comp_restantes = [];
      this.cond_areas_restantes = false;
      this.cantidad_areas_nivel_restantes_objeto = null;
      this.cantidad_areas_nivel_restantes = null;
      this.id_calif_literal_restantes = null;
      this.valor_condicion_restantes = "=";
      this.porcentaje_competencias_restantes = 100;
      this.sino_cumple_con_ni_uno = null;
    },

    radioButtonPromoAuto() {
      // this.LimpiarFiltrado('radio-button-promocion-automatica');
    },
    radioButtonSinoCumple() {
      // this.LimpiarFiltrado('radio-button-sino-cumple-requerimientos');
    },
    radioButtonAreasAleatorias() {
      // this.LimpiarFiltrado('radio-button-areas-aleatorias');
    },
    radioButtonCondAreasRest() {
      // this.LimpiarFiltrado('radio-button-areas-restantes');
    },
  },
};
</script>
<style scoped>
.enunciadoAlert {
  font-size: 14px;
}

.conclass1 {
  background-color: #f3f3f3;
  border-radius: 10px;
}

.conclass2 {
  margin-top: 20px;
  background-color: #f3f3f3;
  border-radius: 10px;
}
.radiogroupnormas {
  margin-top: 0px !important;
}

.colstyle {
  display: flex;
  justify-content: space-around;
  box-shadow: 0px 2px 1px 0px rgba(0, 0, 0, 0.2);
  padding: 0;
}
.styleCards {
  height: 140px;
  /* overflow: auto; */
}
.styleCardsText {
  height: 300px;
}
</style>
